import TYPES from './types';
import { get, put, post, deleteRequest } from 'utils/api';
import { successHandler } from 'common/utils/notifications';
import { updateTableRow, resetTableRowUpdate } from 'store/tables/lists/actions';

export const getIndexes = params => dispatch => {
  dispatch({ type: TYPES.GET_PERSONS.START, payload: { params } });

  return get('/market-indexes', params)
    .then(response => {
      dispatch({ type: TYPES.GET_INDEXES.SUCCESS, payload: response.data });
    })
    .catch(error => dispatch({ type: TYPES.GET_INDEXES.ERROR, payload: error }));
};

export const updateIndex = params => dispatch => {
  const { id, table, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_INDEX.START, payload: { params } });
  dispatch(updateTableRow({ data: params, table }));

  return put(`/market-indexes/${id}`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.UPDATE_INDEX.SUCCESS, payload: response.data });
      dispatch(updateTableRow({ data: response.data.data, table }));
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.UPDATE_INDEX.ERROR, payload: { response: error, params } });
      dispatch(resetTableRowUpdate({ data: params, table }));
      throw error;
    });
};

export const createIndex = params => dispatch => {
  dispatch({ type: TYPES.CREATE_INDEX.START, payload: { params } });

  return post('/market-indexes', params)
    .then(response => {
      dispatch({ type: TYPES.CREATE_INDEX.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Created successfully' }));

      return response.data;
    })
    .catch(error => {
      dispatch({ type: TYPES.CREATE_INDEX.ERROR, payload: error });
      throw error;
    });
};

export const getIndexValues = params => dispatch => {
  const { id, ...rest } = params;

  dispatch({ type: TYPES.GET_INDEX_VALUES.START, payload: { params } });

  return get(`/market-indexes/${id}/values`, { ...rest })
    .then(response => {
      dispatch({ type: TYPES.GET_INDEX_VALUES.SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.GET_INDEX_VALUES.ERROR, payload: error }));
};

export const setBulkValues = data => dispatch => {
  dispatch({ type: TYPES.SET_BULK_VALUES, payload: data });
};

export const updateIndexValue = params => dispatch => {
  dispatch({ type: TYPES.UPDATE_INDEX_VALUE.START, payload: { params } });

  return post(`/market-indexes/values`, params)
    .then(response => {
      dispatch({ type: TYPES.UPDATE_INDEX_VALUE.SUCCESS, payload: response.data });
      dispatch(
        successHandler({
          message: 'Succesfully updated.'
        })
      );
    })
    .catch(error => dispatch({ type: TYPES.UPDATE_INDEX_VALUE.ERROR, payload: error }));
};

export const getIndexesValues = params => dispatch => {
  dispatch({ type: TYPES.GET_INDEXES_VALUES.START, payload: { params } });

  return get(`/market-indexes/values`, params)
    .then(response => {
      dispatch({
        type: TYPES.GET_INDEXES_VALUES.SUCCESS,
        payload: { data: response.data?.data, loadMore: params?.loadMore }
      });
      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.GET_INDEXES_VALUES.ERROR, payload: error }));
};

export const getIndexVisibility = params => dispatch => {
  const { id } = params;
  dispatch({ type: TYPES.GET_INDEX_VISIBILITY.START });

  return get(`/market-indexes/${id}/visibility`)
    .then(response => {
      dispatch({ type: TYPES.GET_INDEX_VISIBILITY.SUCCESS, payload: response.data });
      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.GET_INDEX_VISIBILITY.ERROR, payload: error }));
};

export const updateIndexVisibility = params => dispatch => {
  const { id, ...rest } = params;
  dispatch({ type: TYPES.UPDATE_INDEX_VISIBILITY.START });

  return put(`/market-indexes/${id}/visibility`, rest)
    .then(response => {
      dispatch({ type: TYPES.UPDATE_INDEX_VISIBILITY.SUCCESS, payload: response.data });
      dispatch(successHandler({ title: 'Success!', message: 'Updated successfully' }));
      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.UPDATE_INDEX_VISIBILITY.ERROR, payload: error }));
};
export const deleteIndexValue = params => dispatch => {
  dispatch({ type: TYPES.DELETE_INDEX_VALUE.START, payload: params });

  return deleteRequest(`/market-indexes/values`, params)
    .then(response => {
      dispatch({ type: TYPES.DELETE_INDEX_VALUE.SUCCESS, payload: response.data });
      dispatch(
        successHandler({
          message: 'Succesfully deleted.'
        })
      );
      return response.data;
    })
    .catch(error => dispatch({ type: TYPES.DELETE_INDEX_VALUE.ERROR, payload: error }));
};
